import { inject, Injectable } from '@angular/core';
import { JsonApiResourceMapper, type ResourceCollection, ResourceIdentifierMapperService, ResourceMapper, ResourceTypes } from '@big-direkt/json-api-client';
import { type BreadcrumbItemModel, type NodeModel, NodeTypes, type ParagraphModel } from '@big-direkt/utils/shared';
import { type NodeBigFormResource } from '../resources/node-big-form.resource';

@Injectable({
    providedIn: 'root',
})
@JsonApiResourceMapper
export class NodeBigFormMapper extends ResourceMapper<NodeModel> {
    public static override readonly type: ResourceTypes = ResourceTypes.NodeForm;

    private readonly resourceIdentifierMapper = inject(ResourceIdentifierMapperService);

    public map(resource: NodeBigFormResource, collection: ResourceCollection): NodeModel {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const paragraphs: ParagraphModel[] = this.resourceIdentifierMapper.mapMultiple(resource.relationships.content.data, collection)!;
        const breadcrumbs: BreadcrumbItemModel[] = resource.attributes.breadcrumbs ?? [];

        return {
            type: NodeTypes.Form,
            nodeId: resource.attributes.node_id ?? 0,
            heading: resource.attributes.headline_h1 ?? resource.attributes.title,
            introduction: resource.attributes.text_introduction?.processed,
            appIntroduction: resource.attributes.app_text_introduction ?? undefined,
            pageTitle: {},
            paragraphs,
            breadcrumbs,
            metadata: resource.attributes.metatag ?? [],
            created: resource.attributes.created,
            changed: resource.attributes.changed,
        };
    }
}
